import React from 'react';
import { type TextAreaProps, TextArea as RACTextArea, composeRenderProps } from 'react-aria-components';
import { cn } from '~/shared/components/utils';
import { textInputStyles } from './TextInput';

export function TextArea(props: TextAreaProps) {
	return <RACTextArea className={composeRenderProps(props.className, className => cn(textInputStyles(), className))} rows={4} {...props} />;
}
